export default "__VITE_ASSET__74554446__"